import React from "react";

import style from "./PracticeAddress.module.css";

const PracticeAddress = (props) => {
    return (
        <div className={style.address}>
            {props.address.street_address}<br />
            {props.address.city}, {props.address.state_abbr} {props.address.zip}<br />
            <strong>Lat / Lng:</strong> {props.address.latitude}, {props.address.longitude}
        </div>
    );
}

export default PracticeAddress;